import { createContext, useContext, useState } from 'react';

const AppContext = createContext();

/**
 * AppWrapper is the global context provider for the application that will
 * provide state management that will be shared and accessible by all the
 * components in the application.
 */
export function AppWrapper({ children }) {
  const [user, setUser] = useState(null);
  const [siteLoadingEnabled, setSiteLoadingEnabled] = useState(true);
  const [allDevices, setAllDevices] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [loadingGlobalAssets, setLoadingGlobalAssets] = useState(true);

  let sharedState = {
    user,
    setUser,
    siteLoadingEnabled,
    setSiteLoadingEnabled,
    allDevices,
    setAllDevices,
    allUsers,
    setAllUsers,
    allEvents,
    setAllEvents,
    loadingGlobalAssets,
    setLoadingGlobalAssets,
  };

  return (
    <AppContext.Provider value={sharedState}>{children}</AppContext.Provider>
  );
}

/**
 * useAppContext hook:
 * it can be used to access shared state objects of context provider
 */
export function useAppContext() {
  return useContext(AppContext);
}
